var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('el-container',{attrs:{"direction":"vertical"}},[_c('Header'),_c('app-main',{attrs:{"noMinWidth":_vm.noMinWidth}}),(_vm.showFooter)?_c('el-footer',[_c('MyFooter')],1):_vm._e(),_c('fix-tool-bar')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }